import React, { useEffect, useRef } from "react";
import Navbar from "../../components/navbar/navbar";
import Footer from "../../components/Footer/Footer";
import "./email-verification.css";
import { Navigate, useNavigate } from "react-router-dom";
import { LoaderContext } from "../../context/LoaderContext";
import { useContext } from "react";
import { ConfirmationModal } from "../../components/Modals/ConfirmationModal/confirmation-modal";
import { AcknowledgementModal } from "../../components/Modals/AcknowledgementModal/acknowledgement-modal";
import checkIcon from "../../assets/images/greenCheck.png";
import { POST } from "../../utils/httpUtils";
import { AlertContext } from "../../context/AlertContext";
import { Alert } from "../../utils/genericUtils";

export function EmailVerificationSuccessPage() {
  const { showloader, hideloader } = useContext(LoaderContext);
  const { globalAlert } = useContext(AlertContext);
  const router = useNavigate();

  const selectedPlan = useRef(0);
  const isEmailUpdated = useRef(false);

  useEffect(() => {
    // Parse the query string using URLSearchParams
    let params = new URLSearchParams(window.location.search);
    // Access the parameters
    selectedPlan.current = parseInt(params.get("plan") ?? 0);

    isEmailUpdated.current = params.get("emailUpdated") === "true";
  }, []);

  function GetPlanName(plan) {
    switch (plan) {
      case 0:
        return "Free";
      case 1:
        return "Basic";
      case 2:
        return "Plus";
      case 3:
        return "Pro";
      default:
        return "Free";
    }
  }

  const subTextA =
    selectedPlan.current > 0
      ? `You’ve selected the ${GetPlanName(selectedPlan.current)} plan. Please enter your payment details securely via Stripe.`
      : "Would you like to enable Multi-Factor Authentication? You can chose to do this later.";

  const subTextB = isEmailUpdated.current ? "Your account email has been updated." : "You now have full access to your account.";

  const confirmButtonText = selectedPlan.current > 0 ? "Proceed" : "Setup MFA";
  const denyButtonText = selectedPlan.current > 0 ? "Skip for Now – Use Free Tier" : "Setup Later";

  async function onConfirmHandler() {
    if (selectedPlan.current === 0) SetupMFA();
    else {
      //initiate stripe checkout session now
      showloader();
      let checkout_session_res = await POST("/subscribe", { selectedPlan: selectedPlan.current }, [
        "Authorization",
        sessionStorage.getItem("jwt") ?? localStorage.getItem("jwt"),
      ]);
      hideloader();
      //redirect to the checkout session
      if (checkout_session_res.success) {
        sessionStorage.setItem('stripe-register-flow', 'true');
        window.location.href = checkout_session_res.url;
      }
      else Alert(globalAlert, "error", "Something went wrong!", "please try again later");
    }
  }

  function RenderProperModal() {
    // Parse the query string using URLSearchParams
    let params = new URLSearchParams(window.location.search);
    // Access the parameters
    let registration_url_params = params.get("registered") ?? "";
    //show enable MFA if this is registraion
    if (registration_url_params.toLowerCase() === "true" || selectedPlan.current !== 0) {
      return (
        <ConfirmationModal
          id="email-verification-success-modal"
          icon={checkIcon}
          showDivider={true}
          header="Email Verified Successfully!"
          message={subTextA}
          isActive={true}
          animate={false}
          confirmText={confirmButtonText}
          denyText={denyButtonText}
          onConfirm={onConfirmHandler}
          onDeny={Dashboard}
          confirmClass="btn-green"
        />
      );
    } else {
      return (
        <AcknowledgementModal
          id="email-verification-success-modal"
          icon={checkIcon}
          showDivider={true}
          header="Email Verified Successfully!"
          message={subTextB}
          isActive={true}
          animate={false}
          onAcknowledge={Dashboard}
          buttonText={"Head To My Dashboard"}
        />
      );
    }
  }

  function SetupMFA() {
    router("/mfa-setup");
  }

  function Dashboard() {
    router("/dashboard");
  }

  return (
    <>
      <Navbar />
      <section className="register-page-bg">{RenderProperModal()}</section>
      <Footer />
    </>
  );
}
